export const distance = {
  miles: '{{distance}} mi',
  kilometer: '{{distance}} km',
}
